import Vue from "vue";
import VueRouter from "vue-router";
// import store from "@/store";
// -------module Routes-------//
import { authRoutes } from "./modules/auth";
import { panelRoute } from "./modules/panel";
import { emailVerificationRoutes } from "./modules/email-verification";
// import i18n from "@/plugins/i18n";
// import vuetify from "@/plugins/vuetify";

// import * as types from "@/store/types";
Vue.use(VueRouter);
// get user info
// const userInfo = UserService.getInfo().then(response => {
//   return response.data.data;
// });
const routes = [
  {
    path: "/",
    redirect: `/auth`
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    meta: { transitionName: "slide" },
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/auth/index"),
    async beforeEnter(to, from, next) {
      let isAuth = Vue.$cookies.get("accessToken");
      if (isAuth) {
        next({
          name: "panel" // back to safety route //
        });
      } else {
        next();
      }
    },
    children: authRoutes
  },
  {
    path: "/",
    name: "panel",
    redirect: `/dashboard`,
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "panel-layout" */ "../views/panel/layout/index"
      ),
    async beforeEnter(to, from, next) {
      let isAuth = Vue.$cookies.get("accessToken");
      if (isAuth) {
        next();
      } else {
        if (to.fullPath.includes("submit-order")) {
          next({
            name: "loginForm"
          });
        } else {
          next({
            name: "loginForm", // back to safety route //
            query: { redirectFrom: to.fullPath }
          });
        }
      }
    },
    // async beforeEnter(to, from, next) {
    //   let isAuth = await store.getters[types.auth.getters.GET_IS_AUTH];
    //   console.log(isAuth);
    //   console.log(to, from, next);
    //   if (isAuth) {
    //     next();
    //   } else {
    //     // window.location = "http://p-dev-ex.ernyka.com/login";
    //     next({
    //       name: "login", // back to safety route //
    //       query: { redirectFrom: to.fullPath }
    //     });
    //   }
    // },
    children: panelRoute
  },
  // public
  {
    path: "/",
    name: "public",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "public-layout" */ "../views/panel/layout/publicLayout/index.vue"
      ),
    children: [
      {
        path: "exchange/:pair?",
        name: "exchange",
        props: true,
        meta: {
          transitionName: "slide",
          appBarTitle: "معامله"
        },
        component: () =>
          import(
            /* webpackChunkName: "Exchange" */ "@/views/panel/Market/exchange/index.vue"
          ),
        beforeEnter(to, from, next) {
          const pair = to.params.pair;
          if (pair) {
            to.params.pair = pair.toUpperCase();
          }
          next();
        }
      },
      {
        path: "m-exchange/:pair?",
        name: "m-exchange",
        props: true,
        meta: {
          transitionName: "slide",
          showAppBar: false
        },
        component: () =>
          import(
            /* webpackChunkName: "M-Exchange" */ "@/views/panel/Market/mobileExchange/index.vue"
          )
      },
      {
        path: "markets",
        name: "markets",
        meta: {
          transitionName: "slide",
          appBarTitle: "pageTitles.Markets.market"
        },
        component: () =>
          import(
            /* webpackChunkName: "Markets" */ "@/views/panel/Market/markets/index"
          )
      }
    ]
  },
  {
    path: "/email-verification",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "email-verification" */ "../views/auth/email-verification/index"
      ),
    children: emailVerificationRoutes
  },
  {
    path: "/error-page",
    name: "error-page",
    meta: { errorBody: "", transitionName: "slide" },
    component: () =>
      import(/* webpackChunkName: "error-page" */ "../views/ErrorPage/index")
  },
  {
    path: "*",
    component: () =>
      import(
        /* webpackChunkName: "not-found-page" */ "@/views/panel/NotFoundPage/index"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: "/panel"
});
// function hasQueryParams(route) {
//   return !!Object.keys(route.query).length;
// }
// router.beforeEach((to, from, next) => {
//   console.log(to);
//   if (!hasQueryParams(to) && hasQueryParams(from)) {
//     next({ name: to.name, query: from.query });
//   } else {
//     next();
//   }
//   if (localStorage.getItem("lang")) {
//     i18n.locale = localStorage.getItem("lang");
//   } else {
//     if (to.query.lang) {
//       i18n.locale = to.query.lang;
//       vuetify.rtl = to.query.lang === "fa";
//     } else {
//       i18n.locale = "fa";
//       vuetify.rtl = true;
//     }
//   }
//   if (localStorage.getItem("direction")) {
//     localStorage.getItem("direction") === "rtl"
//       ? (vuetify.rtl = true)
//       : (vuetify.rtl = false);
//   } else {
//     to.query.lang === "fa" ? (vuetify.rtl = true) : (vuetify.rtl = false);
//   }
//   next();
// });
export default router;
